// Repair known UTF-8 punctuation decoded as Latin-1/Windows-1252 in legacy posts.
// Deliberately not a general re-encoding pass: valid names and non-English text stay intact.
const punctuation = ["\u2019", "\u2018", "\u201c", "\u201d", "\u2013", "\u2014", "\u2026", "\u2022", "\u00a0", "\u00a9"];
const windows1252: Record<number, string> = {
  0x80: "\u20ac", 0x82: "\u201a", 0x84: "\u201e", 0x85: "\u2026",
  0x86: "\u2020", 0x87: "\u2021", 0x88: "\u02c6", 0x89: "\u2030",
  0x8a: "\u0160", 0x8b: "\u2039", 0x8c: "\u0152", 0x8e: "\u017d",
  0x91: "\u2018", 0x92: "\u2019", 0x93: "\u201c", 0x94: "\u201d",
  0x95: "\u2022", 0x96: "\u2013", 0x97: "\u2014", 0x98: "\u02dc",
  0x99: "\u2122", 0x9a: "\u0161", 0x9b: "\u203a", 0x9c: "\u0153",
  0x9e: "\u017e", 0x9f: "\u0178",
};
const repairs = punctuation.flatMap((character) => {
  const bytes = Array.from(new TextEncoder().encode(character));
  return [
    [String.fromCharCode(...bytes), character],
    [bytes.map((byte) => windows1252[byte] ?? String.fromCharCode(byte)).join(""), character],
  ];
});

export function repairDisplayText(text: string): string {
  return repairs.reduce((result, [broken, replacement]) => result.split(broken).join(replacement), text);
}

export function repairHtmlText(html: string): string {
  // Leave links, attributes, scripts and CSS untouched; only visible text is repaired.
  return html.replace(/(<script\b[^>]*>[\s\S]*?<\/script\s*>|<style\b[^>]*>[\s\S]*?<\/style\s*>|<[^>]*>)|([^<]+)/gi,
    (match, markup: string | undefined, text: string | undefined) => markup ?? (text ? repairDisplayText(text) : match));
}
